module.exports = "<div class=bio-agent-photo> <img itemprop=image src=\"<%- resize(profile, 'profile_photo', 220) %>\" alt=\"A photo of <%- profile.first_name %> <%- profile.last_name %>\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./templates/bio-photo.html
// module id = 174
// module chunks = 0